import { Axis } from '@visx/xychart';

import { useTickValues } from './useTickValues';
import { type AxisProps, DEFAULT_Y_TICKS } from './utils';

/**
 * Renders the vertical (left) axis with tick labels.
 *
 * The type parameter specifies the type of tick values passed to tickFormat.
 *
 * @example
 * ```tsx
 * type DataPoint = { date: Date; value: number };
 *
 * <XYChart width={500} height={300}>
 *   <YAxis<DataPoint['value']>
 *     numTicks={6}
 *     tickFormat={(value) => `$${value.toFixed(2)}`}
 *   />
 *   <AreaSeries data={data} dataKey="series1" xAccessor={d => d.date} yAccessor={d => d.value} />
 * </XYChart>
 * ```
 */
export const YAxis = <T,>({ tickFormat, numTicks = DEFAULT_Y_TICKS, tickComponent }: AxisProps<T>) => {
  const { yTickValues } = useTickValues({ numYTicks: numTicks });

  return (
    <Axis
      orientation="left"
      tickValues={yTickValues}
      tickFormat={tickFormat}
      tickComponent={tickComponent}
      hideTicks={true}
    />
  );
};
